import { MapPin } from 'lucide-react';
import type { PanelOrganizationDetailDto } from '@icebreaker/shared';
import { Avatar, OrgMark, Tag } from '@icebreaker/ui';
import { numericDateOptions } from '@/features/sales/model/sales-view';
import { useTranslation } from '@/shared/i18n/i18n-provider';
import { VerificationTag } from './organizations-screen';
import styles from './organizations.module.css';

/**
 * KÜNYE (P5 bölüm 1): köşeli kurum monogramı, ad, doğrulama etiketi, kaynak,
 * açılış tarihi ve açan (personel ya da eski kurumda kullanıcı), üye sayısı.
 * Panel katılımcı listesi GÖSTERMEZ; yalnız etkin üye SAYISI (Story C2).
 *
 * ŞEHİR SALT OKUNUR (karar 13.10.2026): panelde kurum künyesini düzenleyen
 * yüzey yoktur, şehri sahip kurum ayarlarından yazar. Boşsa satır çizilmez;
 * public künyedeki gibi konum işaretiyle yazılır.
 */
export function OrganizationIdentityCard({ org }: { org: PanelOrganizationDetailDto }) {
  const t = useTranslation();
  const creatorName = org.createdBy
    ? (org.createdBy.displayName ?? t.t('admin.orgs.owner.removedAccount'))
    : null;
  return (
    <div className={[styles.card, styles.identity].join(' ')}>
      <OrgMark name={org.name} logoUrl={org.logoUrl} fill={org.brandFill} size="xl" />
      <div className={styles.identityText}>
        <div className={styles.identityName}>
          <h1 className={styles.identityTitle}>{org.name}</h1>
          <VerificationTag status={org.verificationStatus} />
          <Tag variant="interest">{t.t(`admin.orgs.sources.${org.provisioningSource}`)}</Tag>
        </div>
        <div className={styles.identityMeta}>
          <span>
            {t.t('admin.orgs.detail.openedAt', {
              date: t.formatDate(org.createdAt, numericDateOptions(t.locale)),
            })}
          </span>
          {creatorName ? (
            <span className={styles.metaPerson}>
              <Avatar name={creatorName} size="xs" />
              {t.t('admin.orgs.detail.openedBy', { name: creatorName })}
            </span>
          ) : null}
          <span>{t.t('admin.orgs.detail.members', { count: org.activeMemberCount })}</span>
          {org.city ? (
            <span className={styles.metaPerson}>
              <MapPin size={14} aria-hidden="true" />
              {org.city}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
}
